exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-reportContentLayout-Attachment-preview{vertical-align:middle}.src-components-reportContentLayout-Attachment-icon{font-size:25px !important}.src-components-reportContentLayout-Attachment-dataBlock{padding:0 10px 0}.src-components-reportContentLayout-Attachment-infoSection{-webkit-box-shadow:0 0 1px rgba(0,0,0,.5);box-shadow:0 0 1px rgba(0,0,0,.5);border:2px solid #b3b3b3 !important;border-radius:0 !important;padding:0 10px 0;margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"preview": "src-components-reportContentLayout-Attachment-preview",
	"icon": "src-components-reportContentLayout-Attachment-icon",
	"dataBlock": "src-components-reportContentLayout-Attachment-dataBlock",
	"infoSection": "src-components-reportContentLayout-Attachment-infoSection"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportContentLayout/Attachment/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportContentLayout/Attachment/styles.scss
// module chunks = 1